import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { InitialRequestConfig } from "../models/flexible/initial-request";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";
import { GET_SCOPES, whereDevices } from "./queries";

export class PrimaryInterventionDateFieldController extends GeneralFieldController {
	getInitialRequestComponents(): InitialRequestConfig {
		return { queries: [GET_SCOPES], variables: { where: whereDevices } };
	}

	override createValidationRule(initialData: unknown, translate: TrFun): Yup.AnySchema {
		return (super.createValidationRule(initialData, translate) as Yup.DateSchema).max(
			new Date(),
			translate("cannot-be-greater-than-today")
		);
	}

	override useControlProps(): FlexControlProps {
		return {
			cannotBeFuture: true,
		};
	}
}
